import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar";
import Employees from "../../components/employees";
import DailyAttendance from "../../components/dailyAttendance";
import Reports from "../../components/reports"
import SanaamPayment from "../../components/sanaamPayments";
// import Leaves from "../../components/leaves";
import OvertimeRequests from "../../components/overtime";
import { ThreeDotsLoading } from "../../components/loading";
import SupportContainer from "../../components/hoverAll/supportContainer";
import UserActivityLogsPage from "../../components/userActivityLogs";

const useStyles = makeStyles(() => ({ root: { display: "flex" } }));


function CompanyDashboard({ match, location }) {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState("Employees");

  const dashboardReducer = useSelector((state) => {
    return state.dashboardReducer;
  });

  const companyDashboardReducer = useSelector((state) => {
    return state.companyDashboardReducer;
  });

  const loginReducer = useSelector((state) => {
    return state.loginReducer;
  });

  useEffect(() => {
    if (match?.params?.activeTab && match.params.activeTab !== activeTab) {
      setActiveTab(match.params.activeTab);
    }
  }, [match, activeTab, setActiveTab]);

  const user = JSON.parse(localStorage.user) || {};
  const hrPath = ["Employees"]

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{`Sanaam - ${activeTab}`}</title>
        <meta property="og:title" content={`Sanaam - ${activeTab}`} />
      </Helmet>
      <ThreeDotsLoading
        showLoader={
          (
            window.location.pathname.includes("company/dashboard/Employees") ?
              false : dashboardReducer?.loading
          ) ||
          companyDashboardReducer?.loading ||
          loginReducer?.loading ||
          companyDashboardReducer?.inviteCompanyAdminLoading
        }
      />
      <Sidebar
        baseURL={"/company/dashboard"}
        activeTab={activeTab}
        tabs={[
          {
            name: "Employees",
            icon: "Employees_Icon.svg",
            isActive: true,
            pathName: "Employees",
          },
          {
            name: "Leaves",
            icon: "Daily Attendance Icon.svg",
            isActive: false,
            pathName: "Leaves",
          },
          {
            name: "Requests",
            icon: "Requests Icon.svg",
            isActive: true,
            pathName: "Requests",
          },
          {
            name: "Reports",
            icon: "Statistics Icon.svg",
            isActive: true,
            comingSoon: false,
            pathName: "Reports",
          },
          {
            name: "User Activity Logs",
            icon: "activity.svg",
            isActive: true,
            comingSoon: false,
            pathName: "UserActivityLogs"
          },
          {
            name: "Sanaam Payments",
            icon: "Sanaam Payments.svg",
            isActive: false,
            comingSoon: true,
            pathName: "SanaamPayments"
          }
        ].filter((value) => !!!user?.is_hr ? true : hrPath.includes(value.pathName))}
      />
      {activeTab === "Employees" && <Employees location={location} />}
      {activeTab === "Daily Attendance" && <DailyAttendance />}
      {/* {activeTab === "Leaves" && <Leaves />} */}
      {activeTab === "Requests" && <OvertimeRequests />}
      {activeTab === "Reports" && <Reports />}
      {activeTab === "SanaamPayments" && <SanaamPayment />}
      {activeTab === "UserActivityLogs" && <UserActivityLogsPage />}

      <SupportContainer />
    </div>
  );
}

export default CompanyDashboard;
